module.exports = __webpack_public_path__ + "static/terminal-works-bw-465cb437bcf96fed63163898d41ba4af.jpg";